/**
 * Created by siroramirez on 09/02/17.
 */
import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions, URLSearchParams, ResponseContentType }  from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/throw';
import {Subject} from "rxjs/Subject";
import { Uploader, UploadItem }      from 'angular2-http-file-upload';

import { AuthService } from "../../../shared/authentication/auth.service";

import { ApiService } from "../../../shared/network/api.service";
import { HttpService } from '../../../shared/network/http.service';
import {User} from "../user";
import {uploadFile} from "../../files/uploadFile";


@Injectable()
export class UsersService {
    private baseOrgUrl = function() {
        return this.apiService.getBaseUrl() + '/organizations/'  + this.authService.getSelectedOrg();
    }

    private usersUrl = this.baseOrgUrl() + '/users/';
    private usersStatisticsUrl = function() {
        return this.baseOrgUrl() + '/users/statistics';
    }
    private usersMeUrl = this.apiService.getBaseUrl() + '/users/me';
    private importUsersUrl = function() {
        return this.baseOrgUrl() + '/users/import';
    }

    private usersLocationUrl = function(userId) {
        return this.baseOrgUrl() + '/users/' + userId + '/lastLocations';
    }

    private users = [];

    constructor (private http: HttpService,
                 private apiService: ApiService,
                 private authService: AuthService,
                 private uploaderService: Uploader,
                 private router: Router) {}

    getUsersStatistics(filters, dateFilter, page, limit, sortBy, sortOrder): Observable<any> {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});
        let params: URLSearchParams = new URLSearchParams();

        for (let filter of Object.keys(filters)) {
            params.set(filter, filters[filter]);
        }

        if (dateFilter.from) {
            var fromDate = dateFilter.from.date;
            params.set('from', fromDate.year + '-' + ("0" + fromDate.month).slice(-2) + '-' + ("0" + fromDate.day).slice(-2));
        }

        if (dateFilter.to) {
            var toDate = dateFilter.to.date;
            params.set('to', toDate.year + '-' + ("0" + toDate.month).slice(-2) + '-' + ("0" + toDate.day).slice(-2));
        }
        if (page) params.set('page', page);
        if (limit) params.set('limit', limit);
        if (sortBy) params.set('sortBy', sortBy);
        if (sortOrder) params.set('sortOrder', sortOrder);

        let options = new RequestOptions({ headers: headers, search: params });
        return this.http.get(this.usersStatisticsUrl(), options)
            .map(this.extractJSON)
            .catch(this.handleError);
    }

    getUsers(): Observable<any> {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});
        let params: URLSearchParams = new URLSearchParams();

        let options = new RequestOptions({ headers: headers, search: params });
        return this.http.get(this.usersUrl, options)
            .map(this.extractJSON)
            .catch(this.handleError);
    }

    getUsersMe(onlySelectedOrg=true): Observable<User> {
        let headers = new Headers ({'Content-Type': 'application/json', 'Authorization': this.authService.getAuthToken()});
        let options = new RequestOptions({ headers: headers });
        return this.http.get(this.usersMeUrl,options)
            .map((res) => this.extractUsersMeData(res, onlySelectedOrg))
            .catch(this.handleError);
    }

    getUser(id): Observable<any> {

        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});

        let params: URLSearchParams = new URLSearchParams();

        let options = new RequestOptions({ headers: headers, search: params });
        return this.http.get(this.usersUrl + id, options)
            .map(this.extractJSON)
            .catch(this.handleError);
    }

    createUser(data): Observable<any> {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.usersUrl, data, options)
            .map(this.extractJSON)
            .catch(this.handleError);
    }

    updateUser(id, data): Observable<any> {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});
        let options = new RequestOptions({ headers: headers });
        return this.http.put(this.usersUrl + id, data, options)
            .catch(this.handleError);
    }

    deleteUser(id) {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});
        let options = new RequestOptions({ headers: headers });
        return this.http.delete(this.usersUrl + id, options)
            .catch(this.handleError)
    }

    importUsers(file) {
        var headers = { 'Accept': 'application/json', 'Authorization':  this.authService.getAuthToken()};
        let myUploadItem = new uploadFile(this.importUsersUrl(), file, headers);

        this.uploaderService.upload(myUploadItem);

        let uploadSubject = new Subject();

        this.uploaderService.onSuccessUpload = (item, response, status, headers) => {
            var parsedResponse = typeof(response) === 'string' ? JSON.parse(response) : response;
            uploadSubject.next({"status":status, "response": parsedResponse});
        };

        this.uploaderService.onErrorUpload = (item, response, status, headers) => {
            var parsedResponse = typeof(response) === 'string' ? JSON.parse(response) : response;
            uploadSubject.next({"status":status, "response": parsedResponse});
        };

        return uploadSubject;
    }

    downloadUsersReport(filters, sortBy, sortOrder) {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});
        let params: URLSearchParams = new URLSearchParams();

        for (let filter of Object.keys(filters)) {
            params.set(filter, filters[filter]);
        }
        if (sortBy) params.set('sortBy', sortBy);
        if (sortOrder) params.set('sortOrder', sortOrder);

        let options = new RequestOptions({ headers: headers, search: params, responseType: ResponseContentType.Blob });
        return this.http.get(this.usersUrl + 'report', options)
            .map(res => res.blob())
            .catch(this.handleError);
    }

    getUserLastLocations(userId): Observable<any> {
        let headers = new Headers({ 'Authorization': this.authService.getAuthToken()});

        let params: URLSearchParams = new URLSearchParams();

        let options = new RequestOptions({ headers: headers, search: params });
        return this.http.get(this.usersLocationUrl(userId), options)
            .map(this.extractJSON)
            .catch(this.handleError);
    }

    private extractJSON(res: Response) {
        let body = res.json();
        return body || {};
    }

    private extractUsersMeData(res: Response, onlySelectedOrg: boolean) {
        let body = res.json();

        var user = body || { };

        if (onlySelectedOrg && user.organizations.length > 1) {
            var selectedOrg = this.authService.getSelectedOrg();
            if (!selectedOrg) {
                //TODO: redirect to login
            }
            var org = user.organizations.find(org => {
                return org._organization._id === selectedOrg;
            })

            if (org) {
                user.organizations = [org];
            } else {
                this.router.navigate(['/login']);
            }
        }

        return user;
    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error.status == 404) {
            errMsg = error.statusText;
        } else {
            const body = error.json() || '';
            let err = body.error || JSON.stringify(body);
            errMsg = err.message || err;
        }
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/users/users/users.service.ts